import { Redirect, Route, Switch } from 'react-router-dom';

import { AdminPage } from '../pages/admin';
import LoginPage from '../pages/login';

import { isAuthenticated } from '../utils/auth';

import { useAuth } from '../contexts/auth';
import { useSnackbar } from '../contexts/snackbar';
import { FSetSnackbarProps } from '../pages/admin/types';
import AudioPage from '../pages/audio';
import SimulcastPage from '../pages/Simulcast';
import { default as VideoPage } from '../pages/player';
import { RedirectRouteProps, RouteProps } from './types';
import ForgotPasswordPage from '../pages/forgotPassword';
import EmailCodeVerificationPage from '../pages/emailCodeVerification';
import CreateNewPsswordPage from '../pages/createNewPassword';
import HybridViewport from '../HybridViewport';

function PublicRoute ({ auth, children }: RouteProps) {
  let isAuth = isAuthenticated();

  //se não estiver autenticado, então retorna o children (login)
  if (!isAuth) {
    return children;
  }

  if(auth.sessionData?.rendering === 'AUDIO') {
    return <Redirect to="/audio" />;
  }

  if(auth.sessionData?.rendering === 'SIMULCAST') {
    return <Redirect to="/simulcast" />;
  }

  return <Redirect to="/video" />
}

function PrivateRoute ({ children }: Omit<RouteProps, "auth">) {
  let isAuth = isAuthenticated();

  if (!isAuth) {
    return <Redirect to="/login" />;
  }

  return children;
}



function HandleRedirectRoute ({ auth, path, children, setFeedback  }: RedirectRouteProps) {
  const isAdmin = auth.sessionData?.role === 'ROLE_ADMIN';

  let userRendering = auth.sessionData?.rendering ?? 'VIDEO';

  if(userRendering === path || isAdmin) {
    return children;
  }
  
  const Routes = {
    'VIDEO': <Redirect to="/video" />,
    'AUDIO': <Redirect to="/audio" />,
    'SIMULCAST': <Redirect to='/simulcast' />
  }

  setFeedback({
    status: true,
    type: 'info',
    message: 'Você não tem permissões de acesso para esse endereço. Será redirecionado para a pagina principal.'
  })
  
  return Routes[userRendering];
}

const Routes = () => {
  const snackbar = useSnackbar();

  function setSnackbar({ status, type, message }: FSetSnackbarProps) { 
    snackbar.setStatus(status);
    snackbar.setType(type);
    snackbar.setMessage(message);
  }
  
  let auth = useAuth();

  return (
    <Switch>
      <Route path='/login' exact>
        <PublicRoute auth={auth}>
          <LoginPage />
        </PublicRoute>
      </Route>

      <Route path='/forgot-password' exact>
        <PublicRoute auth={auth}>
          <ForgotPasswordPage />
        </PublicRoute>
      </Route>

      <Route path='/verify-code' exact>
        <PublicRoute auth={auth}>
          <EmailCodeVerificationPage />
        </PublicRoute>
      </Route>

      <Route path='/create-new-password' exact>
        <PublicRoute auth={auth}>
          <CreateNewPsswordPage />
        </PublicRoute>
      </Route>

      <Route path='/' exact>
        <HandleRedirectRoute auth={auth} path="/" setFeedback={setSnackbar}>
          <VideoPage />
        </HandleRedirectRoute>
      </Route>

      <Route path='/video' exact>
        <PrivateRoute>
          <HandleRedirectRoute auth={auth} path="VIDEO" setFeedback={setSnackbar}>
            <VideoPage />
          </HandleRedirectRoute>
        </PrivateRoute>
      </Route>

      <Route path='/audio' exact>
        <PrivateRoute>
          <HandleRedirectRoute auth={auth} path="AUDIO" setFeedback={setSnackbar}>
            <AudioPage />
          </HandleRedirectRoute>
        </PrivateRoute>
      </Route>

      <Route path='/simulcast' exact>
        <PrivateRoute>
          <HandleRedirectRoute auth={auth} path="SIMULCAST" setFeedback={setSnackbar}>
          <HybridViewport baseWidth={1920}>
            <SimulcastPage />
            </HybridViewport>
          </HandleRedirectRoute>
        </PrivateRoute>
      </Route>

      <Route path='/admin'>
        <PrivateRoute>
          <HandleRedirectRoute auth={auth} setFeedback={setSnackbar}>
            <AdminPage />
          </HandleRedirectRoute>
        </PrivateRoute>
      </Route>
    </Switch>
  )
}

export default Routes;
